const Colors = {
  //dark sky blue version

  // accentDark:"#19b3e6",
  //   accentLightDark:"#bae8f7",
  //   imageHeadContainer:"#55c6ec",
  //   accentDarkDeep:"#17a1cf",
  //   accentLight:"#bae8f7",
  //   whiteLight:"#e8f7fc",
  //     statusbarTransparent:"#510051",
  //   rippleColor:"#fad1db",

  //light green version

  // accentDark:"#19e619",
  //   accentLightDark:"#baf7ba",
  //   imageHeadContainer:"#55ec55",
  //   accentDarkDeep:"#14b814",
  //   accentLight:"#baf7ba",
  //   whiteLight:"#e8fce8",
  //     statusbarTransparent:"#510051",
  //   rippleColor:"#fad1db",

  //Purple version

  // accentDark:"#800080",
  //   accentLightDark:"#e6d1fa",
  //   imageHeadContainer:"#b300b3",//"#a155ec",
  //   statusbarTransparent:"#510051",
  //   accentDarkDeep:"#660066",
  //   accentLight:"#e6d1fa",
  //   whiteLight:"#f2e8fc",
  //   rippleColor:"#fad1db",

  // orange version

  // accentDark:"#e88c30",
  //   accentLightDark:"#f7d9ba",
  //   imageHeadContainer:"#eb9947",
  //   accentDarkDeep:"#cf7317",
  //   accentLight:"#f7d9ba",
  //   whiteLight:"#fcf2e8",
  //   statusbarTransparent:"#510051",
  //   rippleColor:"#fad1db",

  //royal blue version

  // accentDark:"#4770eb",
  //   accentLightDark:"#a3b8f5",
  //   imageHeadContainer:"#557bec",
  //   accentDarkDeep:"#1745cf",
  //   accentLight:"#a3b8f5",
  //   whiteLight:"#F5FCFF",
  //     statusbarTransparent:"#510051",
  //   rippleColor:"#fad1db",

  //rose-red version

  // accentDark:"#cf1745",
  // accentDark:"#b8143d",
  // accentLightDark:"#fad1db",
  // imageHeadContainer:"#EC557A",
  // statusbarTransparent:"#4e081a",
  // imageHeadContainer:"#cf1745",
  //   accentDarkDeep:"#b8143d",
  // accentLight:"#fc83ad",
  // whiteLight:"#fffbfd",
  // rippleColor:"#fad1db",

  //new version 1
  accentDark: "#b8143d",
  accentLightDark: "#DC143C",
  imageHeadContainer: "#DC143C",
  accentDarkDeep: "#b8143d",
  accentLight: "#DC143C",
  whiteLight: "#db899e",
  statusbarTransparent: "#490818",
  rippleColor: "#fad1db",

  //default
  // accentDark:"#DD0651",
  // accentLightDark:"#ffe6ee",
  // imageHeadContainer:"#EC557A",
  // accentDarkDeep:"#ae0440",
  // accentLight:"#fc83ad",
  // whiteLight:"#FDFCFC",
  //   statusbarTransparent:"#510051",
  //   rippleColor:"#fad1db",

  rippleColorCommon: "#A9A9A9",
  grass: "#7ec850",
  gold: "#FFD700",
  green: "#008000",
  greenshade: "#CCE5CC",
  greenlight: "#e7f3e7", //"#ddeedd",
  black: "#000000",
  messageManagePanel: "#ff1a1a",

  accent: "#FF0059",
  coffee: "#C10303",

  blueLight: "#DBF3FA",
  blueWhiteLight: "#F5FCFF",
  redWhiteLight: "#ffefea",
  redlight: "#ffcccc",
  fbColor: "#45619d",

  team1Color: "#F4F6F6",
  team2Color: "#606060",

  Orange: "#FFA500",
  btnOrange: "#31278b",
  btnBlack: "#212F3D",
  grayColor: "#F4F6F6",
  positiveButton: "#4AB13E", //"#707070",
  negativeButton: "#31278b", //"#F88863",
  recenterButton: "#2a2277", //"#F55A26",
  menuLine: "#AEAEAE",
  forceLogout: "#31278b", //"#F88863",
  start: "#3DF237",
  startBoarder: "#707070",
  dialogHead: "#606060",
  white: "#FFFFFF",
  addresSubHead: "#747480",
  lineGrey: "#C1C1C1",
  landingRed: "#31278b", //"#F55A26",
  userType: "#5340FB",
  statusGreen: "#06B189",
  paymentStatusYellow: "#F2DF37",
  paymentStatusRed: "#F55A26",
  paymentStatusBorder: "#E5E5E5",
  paymentInvoice: "#A8A7A7",
  paymentPicker: "#E4E7E8",
  fltrNegativeButton: "#f4f4f4",
  fltrSelectButton: "#FED8B1",
  errorMsg: "#FF0000",
  darkGray: "#A9A9A9",
  positiveButtonBlur: "#707070BF",
  negativeButtonBlur: "#F88863BF",
  whiteBlur: "#FFFFFFBF",
  overlayColor: "#5D5E5F",
  red: "#CD0000",
  filterGrey: "#F3F3F3",
  OrderCartEdit: "#FAFAFA",
  Offroute: "#e9ecf7",
};
export default Colors;
